import actions from './actions'
import getters from './getters'
import { mutations } from './mutations'
import Custom from './custom'

// Panel-owned data - reset by resetPanelState when the citizen enters a different
// panel. Common-service data (commonObj / commonObjCommonConfig) is never reset.
const defaultLrcpnObj = () => ({
  lrcpnUserStatus: '',
  hasDropdownLoaded: false,
  feeNamesList: [],
  serviceNamesList: [],
  stepNamesList: [],
  menuWiseStepList: [],
  dynamicFormList: [],
  serviceSteps: [],
  serviceStepForm: [],
  dynamicButtonList: [],
  lrcpnUserDetails: {},
  profileLabel: {},
  seviceStepWiseButtonList: [],
  menuInfoList: [],
  autoGenNumTypeList: [],
  reportMenuList: [],
  labList: [],
  activeIngredientList: [],
  agricultureProductList: [],
  agricultureProductTypeList: [],
  countryList: [],
  fertilizerName: [],
  preconditionList: [],
  cropList: [],
  // localizeExternalLrcpnDropdown / setPanelObj .map() these, and the common dashboard localizes before the lrcpn dropdowns load
  stepFeeList: [],
  foreignEnlishmentList: [],
  marketList: []
})

// Full default state - restored by resetExternalState on admin/office login
const defaultState = () => ({
    lrcpnObj: defaultLrcpnObj(),
    static: {
      perPage: 10,
      dateFormat: 'DD/MM/YYYY',
      fiscaleYear: 'YYYY-YYYY',
      timeFormat: 'h:m',
      loading: false,
      listReload: false,
      hasDropdownLoaded: false
    },
    commonObj: {
      hasDropdownLoaded: false,
      divisionList: [],
      districtList: [],
      upazilaList: [],
      unionList: [],
      officeTypeList: [],
      officeList: [],
      designationList: [],
      gradeList: [],
      fiscalYearList: [],
      genderList: Custom.genderList,
      religionList: Custom.religionList,
      orgList: [],
      listLoad: false
    },
    commonObjCommonConfig: {
      hasDropdownLoaded: false,
      bankList: [],
      cityCorporationList: [],
      pauroshobaList: [],
      branchList: [],
      wardList: [],
      countryList: []
    }
})

const state = defaultState()

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations: Object.assign({}, mutations, {
    resetPanelState (state) {
      state.lrcpnObj = defaultLrcpnObj()
    },
    resetExternalState (state) {
      Object.assign(state, defaultState())
    }
  })
}
